import('./select_station_view.css')
import _http_v1 from '../../../../../http_requests/_http_v1'
import StationList from './stations_list'
import toast from '../../../../../components/toast/toast'

export default function SelectStationView(options){
    let container = options.container
    let container_element = document.createElement('div')
    let map
    let stationsList
    let confirmButton = new ConfirmButton({container: '.select-station-view-container .right-container'})
    let AREA_RADIUS = 10000
    let CLOSEST_LIMIT = 3

    let closest_stations
    initialize.call(this)

    function initialize(){
        console.log(this);
        $(container_element).addClass('select-station-view-container')
        $(container).append(container_element)
        setStage()
        eventsHandler.call(this)
    }
    this.show = (station_prefixes, plus_selected) =>{
        stationsList = new StationList({container: '.select-station-view-container .right-container', station_prefixes: station_prefixes})
        map = new MapComponent({map_id:'aux_map', container: '.select-station-view-container .left-container'})
        this.setContainerSize()
        setTimeout(_=>{

            if(!map.getMap()){
                setMap()
            } else {
                clearMap()
            }

            map.showOverlay()
            $(container_element).addClass('show')
            stationsList.generate()
            stationsList.loading(true)

            getStations(station_prefixes).then(_=>{
                stationsList.loading(false)
                map.hideOverlay()
                updateStationStatus(plus_selected)
                // this.generateStationsList()
            })
            showAreaOnMap(station_prefixes)
        }, 500)
    }

    this.hide = () =>{
        $(container_element).removeClass('show')
    }

    function clearMap(){
        map.clearLayer('markers')
        map.clearLayer('area')
    }

    function setMap(){
        map.generate()
        map.addLayerToMap(new L.featureGroup(),'markers')
        map.addLayerToMap(new L.featureGroup(),'area')
    }

    function showAreaOnMap(station_prefixes){
        station_prefixes.map(station=>map.addLayerToFeature('area',L.circle([station.latitude, station.longitude], {radius: AREA_RADIUS, className:'closest-stations-area', opacity: 0.6, fillOpacity:0.1})))
        map.zoomToLayer('area')
    }

    function getStations(station_prefixes){
        return new Promise((resolve,reject)=>{
            
            let latLngs = station_prefixes.map(x=> ({lat: x.latitude, lng: x.longitude, id: x.prefix}))

            _http_v1.request('station_prefixes/closest', 'GET', {latLngs:latLngs, distance: AREA_RADIUS/1000, only_with_data: true}).then(data=>{
                closest_stations = data.json
                prepareStations()
                stationsList.setProgress(100, "Feito :)")
                stationsList.setStationsList(closest_stations)
                generateMarkers(closest_stations)
                resolve()
            })
        })        
    }

    function updateStationStatus(plus_selected){
        closest_stations.forEach(station=>{
            if(plus_selected.includes(station.id)){
                station.select(true)
            }
        })
    }

    function prepareStations(){
        closest_stations.forEach(station=>{
            station.selected = false //definindo status padrão da seleção
            station.select = selected =>{
                let boolean = selected || !station.selected
                if(canSelect(boolean)){
                    station.selected = boolean
                    $(station.marker._icon).toggleClass('active', boolean)
                    $(station._tr.select(boolean))
                    $(document).trigger('closest-stations:list-item-click', station)    
                } else {
                    toast.show({text: `Máximo de postos PLU: ${CLOSEST_LIMIT}`})

                }
                
            }
            station.hover = hovered =>{
                $(station.marker._icon).toggleClass('highlight', hovered)
            }
        })
    }

    function canSelect(boolean){
        return (boolean && closest_stations.filter(x=> x.selected).length >= CLOSEST_LIMIT) ? false : true
    }

    function generateMarkers(station_prefixes){
        map.clearLayer('markers')
        station_prefixes.forEach(station=>{
            let icon = L.divIcon({
                className: 'aux-map-plu-icon',
                html: '<i class="fas fa-tint"></i>',
                iconSize: [20, 20],
                iconAnchor: [10,10]
            });

            let marker = L.marker([station.latitude, station.longitude], {icon: icon});

            marker.on('click', _=>{
                station.select()
            })

            map.addLayerToFeature('markers', marker, station.id)
            station.marker = marker
        })
        if(station_prefixes.length > 0){
            // map.zoomToLayer('markers')
        }
    }

    function eventsHandler(){
        let context = this
        $(document).on('closest-stations:list-item-click', () =>{
            let selected_ones = closest_stations.filter(x=>x.selected)
            if(selected_ones.length > 0){
                confirmButton.show()
            } else {
                confirmButton.hide()
            }
        })
        $(document).on('select-station-view:hide', _ =>{
            let selected_ones = closest_stations.filter(x=>x.selected)
            $(document).trigger('plu-stations:set', {stations: selected_ones})
            context.hide()
        })
        $(document).on('select-station-view:confirm', _ =>{
            $(document).trigger('select-station-view:hide')
        })
        $(document).on('click','.closest-station-btn-close', _ => {
            $(document).trigger('select-station-view:hide')
        })
    }

    this.generateStationsList = _ =>{
        
    }

    function getClosestStations(selected_ones, plu_stations){
        let closest_stations = []
        selected_ones.forEach(F=>{
            let lat = F.station.latitude
            let lng = F.station.longitude

            plu_stations.forEach(P=>{
                let plat = P.station.latitude
                let plng = P.station.longitude
                let distance = calculateDistance(lat, lng, plat, plng)
                if(distance <= AREA_RADIUS/1000){
                    closest_stations.push({...P, distance: distance})
                }
            })
        })

        return closest_stations
    }

    function setStage(){
        $(container_element).html("<div class='left-container'></div><div class='right-container'></div><div class='closest-station-close-container'><i class='fas fa-times closest-station-btn-close'></i></div>")
    }

    this.setContainerSize = () =>{
        $(container_element).css({
            'height': $(container).height(),
            'width': $(container).width()
        })
        if(map && map.getMap()){
            map.getMap().invalidateSize()
        }
    }

    function calculateDistance(lat1, lon1, lat2, lon2) {
        const earthRadius = 6371; // Earth's radius in km
        const dLat = deg2rad(lat2 - lat1);
        const dLon = deg2rad(lon2 - lon1);
        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(deg2rad(lat1)) *
            Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = earthRadius * c;
        return distance;
      }
      
      function deg2rad(deg) {
        return deg * (Math.PI / 180);
    }

    function ConfirmButton(options){
        let container = options.container
        let button_el
        
        initialize()

        this.show = _ =>{
            $(button_el).off()
            $(button_el).on('click', _ =>{
                $(document).trigger('select-station-view:confirm')
            })

            if(!button_el.parentNode){
                $(container).append(button_el)
                setTimeout(_=>{
                    $(button_el).addClass('show')
                },100)
            }
        }

        this.hide = _ =>{
            $(button_el).removeClass('show')
            setTimeout(_=>{
                button_el.remove()
            },300)
            
        }

        function initialize(){
            button_el = document.createElement('button')
            button_el.type == 'button'
            button_el.innerText = "Confirmar"
            $(button_el).addClass('closest-station-list-btn-confirm')
            $(button_el).on('click', _ =>{
                $(document).trigger('select-station-view:hide')
            })
        }
    }

}